import styled from 'styled-components';

export const AutoSuggestList = styled.ul`
  z-index: 99;
  position: absolute;
  top: 6rem;
  left: 0px;
  list-style-type: none;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 2px 14px 0px;
  transform: translateY(4px);
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  background: rgb(255, 255, 255);
  border-radius: 4px;
`;
export const ListItem = styled.li`
  display: flex;
  align-items: center;
  font-size: 1.4rem;
  border-top: 1px solid rgb(220, 221, 222);
  padding: 1rem 1.6rem;
  background: rgb(255, 255, 255);
  cursor: pointer;
`;
